import { render, staticRenderFns } from "./DespesaCreate.vue?vue&type=template&id=482c9e62"
import script from "./DespesaCreate.vue?vue&type=script&lang=js"
export * from "./DespesaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports